module.exports = __webpack_public_path__ + "img/crypto-ada.95f83a18.svg";